import React, { useRef, useState } from "react";
import { Headline, Layer, Paragraph } from "@lsg/components";
import "./PersonCard.css";

const PersonCard = ({
    name,
    position,
    education,
    url,
    imageSrc,
    imageAlt,
    layerContent,
    layerCloseLabel = "Get back",
    className = "",
}) => {
    const [isLayerOpen, setIsLayerOpen] = useState(false);
    const generatedIdRef = useRef(`person-card-${Math.random().toString(36).slice(2, 10)}`);

    const layerTitleId = `${generatedIdRef.current}-layer-title`;
    const descriptionId = `${generatedIdRef.current}-description`;

    const openLayer = () => setIsLayerOpen(true);
    const closeLayer = () => setIsLayerOpen(false);

    return (
        <div className={`person-card ${className}`.trim()}>
            <button
                type="button"
                className="person-card__media-button"
                onClick={openLayer}
                aria-haspopup="dialog"
                aria-label={`Otwórz wizytówkę: ${name}`}
            >
                <img className="person-card__image" src={imageSrc} alt={imageAlt || name} />
            </button>

            <div className="person-card__content">
                <Headline size="h4" as="h3">
                    {name}
                </Headline>
                <div className="person-card__meta">
                    {position && <Paragraph className="person-card__text">{position}</Paragraph>}
                    {education && <Paragraph className="person-card__text">{education}</Paragraph>}
                </div>
            </div>

            <Layer
                closeLinkLabel={layerCloseLabel}
                returnFocus={true}
                open={isLayerOpen}
                onCloseClick={closeLayer}
                ariaLabelledBy={layerTitleId}
                htmlAttrs={{ "aria-describedby": descriptionId }}
            >
                <div className="person-card__layer-content" id={descriptionId}>
                    <Headline size="h3" as="h2" id={layerTitleId}>
                        {name}
                    </Headline>
                    {(position || education) && (
                        <Paragraph>
                            {[position, education].filter(Boolean).join(" • ")}
                        </Paragraph>
                    )}
                    {url && (
                        <a
                            className="person-card__layer-link"
                            href={url}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Paragraph>LinkedIn Profile</Paragraph>
                        </a>
                    )}
                    {layerContent}
                </div>
            </Layer>
        </div>
    );
};

export default PersonCard;

